import { Box, Card, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import WTypography from '../../../../Components/whiteTypography'
import { makeGetRequest } from '../../../../utils/api'
import urls from '../../../../utils/urls'

import DonutChart from './DonutChart'
import StackedBarChart from './StackedBarChart'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function MesActifs() {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [reports, setReports] = useState()
  const [headerValue, setHeaderValue] = useState(null)
  const [barData, setBarData] = useState({})
  const [sousCat, setSousCat] = useState(false)

  useEffect(() => {
    fetchMesActifs('year')
    fetchMesActifsBar()
  }, [])
  const fetchMesActifs = async (yearOrDate, year = null) => {
    setSousCat(false)
    let url = `/api/Finance/reports/${yearOrDate}/?calcul=assets.js`
    if (year) {
      url += `&year=${year}`
    }
    const { data } = await makeGetRequest(url, {}, true)
    setReports({ ...data })
    setHeaderValue(data.calculation.header_value)
  }

  const fetchMesActifsBar = async (year = null, accountType = null) => {
    let url = urls.fetchDashboardDetailsEvolutions('mesactifs')
    if (accountType) {
      url += `?account_type=${accountType}`
    }
    if (year) {
      url += `?year=${year}`
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setBarData({ ...response.data })
    }
  }

  return (
    <Grid container spacing={2}>
      <Grid item sm={4} xs={12}>
        <Card className="dashboard_card__root">
          <Box className="dashboard_card__header">
            <WTypography component={'span'} variant="h5">
              {t('dashboardDetail.assetsDistribution')}
            </WTypography>
            <WTypography component={'span'} variant="h5">
              {headerValue} €
            </WTypography>
          </Box>

          <Box mt={2} minWidth={3}>
            <DonutChart
              setHeaderValue={setHeaderValue}
              reports={reports}
              fetchMesActifs={fetchMesActifs}
              sousCat={sousCat}
              fetchMesActifsBar={fetchMesActifsBar}
            />
          </Box>
        </Card>
      </Grid>

      <Grid item sm={8} xs={12}>
        <StackedBarChart
          barData={barData}
          fetchMesActifsDonut={fetchMesActifs}
          filters={fetchMesActifsBar}
        />
      </Grid>
    </Grid>
  )
}

export default MesActifs
